import React from 'react'
import { useTranslation } from 'react-i18next'
import {useInjection} from 'dna-react-ioc'
import {RangePickerContainer, SelectWithTitleContainer, TTabsContainerStore} from '@/components'
import styles from './styles.scss'
import {
    EcomOverviewRangePickerStoreSymbol,
    OverviewECOMCurrencySelectStoreSymbol,
    OverviewPOSCurrencySelectStoreSymbol,
    OverviewTabsContainerStoreSymbol, PosOverviewRangePickerStoreSymbol
} from '@/pages/Overview'


export const OverviewTabsExtraContent = () => {
    const { t } = useTranslation()

    const tabsStore = useInjection<TTabsContainerStore>(OverviewTabsContainerStoreSymbol)

    return (
        <div className={styles.tabBarExtra}>
            <SelectWithTitleContainer
                className={styles.currency}
                injectableIdentifier={(
                    tabsStore.value === 'onlinePayments'
                        ? OverviewECOMCurrencySelectStoreSymbol
                        : OverviewPOSCurrencySelectStoreSymbol
                )}
                displayValue={t('Overview.currency')}
            />
            <RangePickerContainer
                key={tabsStore.value === 'onlinePayments' ? 'onlinePayments' : 'PosPayments'}
                injectableIdentifier={
                    tabsStore.value === 'onlinePayments'
                        ? EcomOverviewRangePickerStoreSymbol
                        : PosOverviewRangePickerStoreSymbol
                }
            />
        </div>
    )
}
